import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Icon } from "@/components/Icon";
import { tg } from "@/lib/telegram";

// Плаваюча кнопка «вгору» — зʼявляється коли сторінку прокрутили вниз
// (юзер 2026-06-11: «листав багато — одною кнопкою повернутися нагору»).
// Сторінка скролиться на window. Використовується в стрічці вакансій і
// в читалці статей Бази знань (юзер 2026-06-12).
export function ScrollTopButton() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 800);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  // Портал у body: інакше кнопка сидить усередині .page-transition, який
  // тримає transform → containing block для fixed, і кнопка позиціонувалась
  // відносно нього, а не viewport. Через портал — справжній fixed до екрана.
  return createPortal(
    <button
      type="button"
      onClick={() => {
        tg()?.HapticFeedback?.impactOccurred?.("light");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      aria-label="Нагору"
      className="fixed right-4 z-[60] grid h-11 w-11 place-items-center rounded-full bg-primary text-white shadow-card active:scale-90 transition"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 20px)" }}
    >
      <Icon name="arrow-right" size={16} color="#FFFFFF" className="-rotate-90" />
    </button>,
    document.body,
  );
}
